import { render } from "./AddRoomSectionDialog.vue?vue&type=template&id=4c46738b"
import script from "./AddRoomSectionDialog.vue?vue&type=script&lang=js"
export * from "./AddRoomSectionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__